<template>
    <div class="col-xs-6 col-sm-4 col-md-7 div-center">
        <div class="list-group">
            <a href="#idRequest" class="list-group-item wfeList" data-toggle="modal"><span>{{$t(items[0].title)}}</span></a>
            <br/>
            <router-link :to="{path: '/flows'}" class="list-group-item wfeList">{{$t(items[1].title)}}</router-link>
            <!--
            <router-link :to="{path: '/favorites'}" class="list-group-item">{{$t(items[2].title)}}</router-link>
            <router-link :to="{path: '/messages'}" class="list-group-item">{{$t(items[3].title)}}</router-link>
            -->

            <a v-show="false" href="#idRequestResponse" ref="refResponse" data-toggle="modal">test ref</a>
        </div>

        <div id="idRequest" class="modal fade" tabindex="-1">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog vertical-align-center">
                    <div class="modal-content">
                        <div class="modal-header textCenter">
                            {{$t('home.request')}}
                            <br/>
                            {{$t('request.confirm')}}
                        </div>
    
                        <div class="modal-footer" style="margin: 0 auto;">
                            <button type="button" class="btn btn-primary" data-dismiss="modal" @click='makeRequest'>{{$t('common.ok')}}</button>
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('common.cancel')}}</button>
                        </div>
                    </div><!-- /.modal-content -->
                </div><!-- /.modal-dialog -->
            </div>
        </div>

        <div id="idRequestResponse" class="modal fade" tabindex="-1">
            <div class="vertical-alignment-helper">
                <div class="modal-dialog vertical-align-center">
                    <div class="modal-content">
                        <div class="modal-body textCenter">
                            {{$t('home.request')}}
                            <br/>
                            {{$t('request.accepted')}}
                            <br/>
                            <span style="text-align: left;">No. {{getAgvUUID}}</span>
                        </div>
    
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">{{$t('common.ok')}}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    
        <!--
        <hr />
        <div>param: {{ myquery }}</div>
        -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data() {
        return {
            myquery: '',
            items: [
                {title: 'home.request'},
                {title: 'home.jobs'},
                {title: 'home.favorites'},
                {title: 'home.messages'},
            ]
        }
    },

    created() {
        this.myquery = this.$route.query
        if (typeof(this.$route.query.identity) != 'undefined') {
            this.checkPassword(this.$route.query.password)
            this.checkRegistration(this.$route.query.identity, this.$route.query.name, this.$route.query.device)
        }
    },

    computed: mapGetters([
        'getName',
        'getIdentity',
        'getEmail',
        'getPushRegistered',
        'getAgvUUID'
    ]),

    methods: {
        checkPassword(pwd) {
            this.myquery = 'checkPassword: '+pwd+'</br>\n'
        },
        checkRegistration(identity, name, device) {
            //console.log('checkRegistration(), identity: ', identity, ', device: ', device)
            this.myquery += ('pushRegistered: '+this.getPushRegistered+'</br>\n')
            this.myquery += ('identity: '+identity+'</br>\n')
            this.myquery += ('name: '+name+'</br>\n')
            // Uncomment for test to do registration every time
            //if (this.getPushRegistered == false) {
                let jobj = {
                    'Identity': identity,
                    'Token': device
                }
                this.pushRegisterDevice(jobj)
                
                let info = {
                    'Identity': identity,
                    'Name': name
                }
                this.actSaveUserInfo(info)
            //}
        },
        async makeRequest() {
            let jobj = {
                'initiator': this.getName,
                'identity': this.getIdentity,
                'email': this.getEmail
            }
            let ret = await this.actSubmitRequest(jobj) // double async/await is neccessary
            this.$refs.refResponse.click()
        },
        ...mapActions([
            'actSaveUserInfo',
            'pushRegisterDevice',
            'actSubmitRequest'
        ])
    }
}
</script>

<style scoped src='../assets/css/custom.css'></style>

<style scoped>
.wfeList {
    background-color: purple;
    color: white;
    margin: "0 auto";
    text-align: center;
}

.textCenter {
    text-align: center; 
    margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue